<template>
    <div class="flex flex-row flex-wrap lg:grid lg:grid-cols-[max-content_auto_1fr] lg:auto-rows-min gap-1.5">
        <button
            v-for="tab in tabs"
            :key="tab.path"
            :class="currentTabPath === tab.path ? 'body-small-bold max-lg:border-valence-primary-500 lg:bg-white lg:border-valence-grey-250' : 'border-transparent'"
            class="body-small text-valence-grey-600 text-center lg:text-left px-3 lg:px-2.5 py-2 max-lg:border-b-2 lg:border lg:rounded-md hover:font-semibold transition-[font-weight,background-color,border-color] flex items-center justify-center lg:grid lg:grid-cols-subgrid lg:col-span-full whitespace-nowrap shrink-0 lg:shrink"
            @click="emit('tab-selected', tab.path)">
            <span>{{ tab.label }}</span>
            <span v-if="tab.badge" class="ml-1.5 lg:ml-0 inline-flex items-center rounded-full bg-gradient-to-br from-valence-purple to-valence-purple/50 p-px">
                <span
                    class="inline-flex items-center rounded-full bg-gradient-to-br from-valence-purple/30 to-valence-purple/10 px-1.5 py-px text-[10px] font-semibold text-white uppercase">
                    {{ tab.badge }}
                </span>
            </span>
        </button>
    </div>
</template>

<script setup lang="ts">
import type { MaybeRef } from "vue";

import type { TabPath } from "./types";

const { tabs, currentTabPath } = defineProps<{
    tabs: ReadonlyArray<{ label: MaybeRef<string>; path: TabPath; badge?: string }>;
    currentTabPath: string;
}>();

const emit = defineEmits<{
    "tab-selected": [path: TabPath];
}>();
</script>
